import React, { useEffect } from 'react';
import { isEqual } from 'lodash';
import { PrimaryButton } from 'src/shared/components/button/Button';
import { HabitatInsightsGeoJsonFile } from 'src/shared/types';
import { useAppSelector } from 'src/store';
import { getCurrentHabitatInsightsUploadFormState } from 'src/app/habitat-insights/state/habitatInsightsUploadSelector';
import HabitatInsightsSamplesReviewMap from './components/habitat-insights-samples-review-map/HabitatInsightsSamplesReviewMap';
import HabitatInsightsSampleSidebar from './components/habitat-insights-samples-sidebar/HabitatInsightsSamplesSidebar';
import styles from './ReviewAndSubmit.module.scss';
import useHabitatInsightsUpload from '../../hooks/useHabitatInsightsUpload';

const ReviewAndSubmit = () => {
    const formState = useAppSelector(getCurrentHabitatInsightsUploadFormState);
    const { onFormChange, submitHabitatInsightsUploadForm, submitProjectInfo } = useHabitatInsightsUpload();

    const habitatInsightsSamplesData: HabitatInsightsGeoJsonFile = JSON.parse(formState.uploadedFileContent);

    useEffect(() => {
        if (habitatInsightsSamplesData && habitatInsightsSamplesData.features) {
            const newSites = habitatInsightsSamplesData.features;
            if (!isEqual(newSites, formState.sites)) {
                onFormChange({
                    sites: newSites,
                });
            }
        }
    }, [habitatInsightsSamplesData, formState.sites, onFormChange]);

    const onSubmit = async () => {
        try {
            onFormChange({ loading: true });
            const createProjectInfo = await submitProjectInfo();
            if (createProjectInfo) {
                await submitHabitatInsightsUploadForm();
            }
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div className={styles.reviewAndSubmit}>
            <div className={styles.container}>
                <div className={styles.mainContent}>
                    <HabitatInsightsSamplesReviewMap data={habitatInsightsSamplesData.features} />
                </div>
                <div className={styles.sidebar}>
                    <HabitatInsightsSampleSidebar data={habitatInsightsSamplesData.features} />
                </div>
            </div>
            <div className={styles.bottomNavigation}>
                <PrimaryButton onClick={onSubmit}>Submit</PrimaryButton>
            </div>
        </div>
    );
};

export default ReviewAndSubmit;
